module.exports = __webpack_public_path__ + "img/icon-ywqn-item-1.1d3415b5.png";